import { getThemeStyles } from "./auth-service-tools532.js";
import { resolveStyle } from "./auth-service-tools533.js";
import { resolveStyles } from "./auth-service-tools194.js";
import { resolveVars } from "./auth-service-tools534.js";

function getStyle(_ref) {
  let {
    theme,
    themeName,
    selector,
    options,
    props,
    stylesCtx,
    rootSelector,
    styles,
    style,
    vars,
    varsResolver,
    headless,
    withStylesTransform
  } = _ref;
  return { ...(!withStylesTransform && getThemeStyles({
      theme,
      themeName,
      props,
      stylesCtx,
      selector
    })),
    ...(!withStylesTransform && resolveStyles({
      theme,
      styles,
      props,
      stylesCtx
    })[selector]),
    ...(!withStylesTransform && resolveStyles({
      theme,
      styles: options == null ? void 0 : options.styles,
      props: (options == null ? void 0 : options.props) || props,
      stylesCtx
    })[selector]),
    ...resolveVars({
      theme,
      props,
      stylesCtx,
      vars,
      varsResolver,
      selector,
      themeName,
      headless
    }),
    ...(rootSelector === selector ? resolveStyle({
      style,
      theme
    }) : null),
    ...resolveStyle({
      style: options == null ? void 0 : options.style,
      theme
    })
  };
}

export { getStyle };